import { connect } from 'react-redux';
import Header from '../../components/Header';
import { custEmailSelector } from '../../selectors/CustomerSelectors';

const mapStateToProps = (state) => ({
  userEmail: custEmailSelector(state),
});

export default connect(mapStateToProps)(Header);
